
import Button from '../../../components/base/Button';

export default function FeaturedPropertiesSection() {
  const properties = [
    {
      id: 1,
      image: 'https://public.readdy.ai/ai/img_res/14e5330f6eaa0323296792702ed0c78f.jpg',
      price: '5,980万円',
      title: '渋谷区神宮前 新築マンション',
      location: '渋谷区神宮前',
      specs: ['3LDK', '75㎡', '築0年'],
      features: ['駅徒歩3分', 'ペット可', 'オートロック'],
      type: '売買'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20modern%20house%20exterior%20with%20garden%2C%20contemporary%20architecture%2C%20clean%20white%20walls%2C%20large%20windows%2C%20elegant%20entrance%2C%20professional%20real%20estate%20photography%2C%20bright%20daylight%2C%20luxury%20residential%20property&width=400&height=300&seq=prop2&orientation=landscape',
      price: '8,500万円',
      title: '世田谷区 デザイナーズ一戸建て',
      location: '世田谷区',
      specs: ['4LDK', '120㎡', '築2年'],
      features: ['駐車場付き', '庭付き', 'リフォーム済み'],
      type: '売買'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20building%20exterior%20with%20modern%20architecture%2C%20glass%20facade%2C%20elegant%20entrance%2C%20professional%20real%20estate%20photography%2C%20urban%20setting%2C%20high-end%20residential%20complex%2C%20contemporary%20design&width=400&height=300&seq=prop3&orientation=landscape',
      price: '25万円/月',
      title: '港区六本木 高級賃貸マンション',
      location: '港区六本木',
      specs: ['2LDK', '65㎡', '築5年'],
      features: ['コンシェルジュ', 'ジム付き', '24時間セキュリティ'],
      type: '賃貸'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Modern%20investment%20property%20apartment%20building%2C%20contemporary%20architecture%2C%20multiple%20units%2C%20professional%20real%20estate%20photography%2C%20urban%20location%2C%20high-yield%20rental%20property%2C%20clean%20modern%20design&width=400&height=300&seq=prop4&orientation=landscape',
      price: '3,200万円',
      title: '新宿区 投資用ワンルーム',
      location: '新宿区',
      specs: ['1R', '25㎡', '築3年'],
      features: ['高利回り', '駅近', '管理良好'],
      type: '投資'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            新着・おすすめ物件
          </h2>
          <p className="text-lg text-gray-600">
            厳選した優良物件をご紹介
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-product-shop>
          {properties.map((property) => (
            <div key={property.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <div className="relative">
                <img
                  src={property.image}
                  alt={property.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    property.type === '売買' ? 'bg-blue-100 text-blue-800' :
                    property.type === '賃貸' ? 'bg-green-100 text-green-800' :
                    'bg-purple-100 text-purple-800'
                  }`}>
                    {property.type}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="text-2xl font-bold text-blue-600 mb-2">
                  {property.price}
                </div>
                
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {property.title}
                </h3>
                
                <div className="flex items-center text-gray-600 mb-4">
                  <i className="ri-map-pin-line mr-1"></i>
                  <span className="text-sm">{property.location}</span>
                </div>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {property.specs.map((spec, index) => (
                    <span key={index} className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
                      {spec}
                    </span>
                  ))}
                </div>
                
                <div className="space-y-1 mb-4">
                  {property.features.map((feature, index) => (
                    <div key={index} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </div>
                  ))}
                </div>
                
                <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer">
                  詳細を見る
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button variant="outline" size="lg">
            すべての物件を見る
          </Button>
        </div>
      </div>
    </section>
  );
}
